// src/pages/SellerIntelligence/Seasonal/Seasonal.js
//
// Seasonal Performance Analyser.
//
// Four surfaces over one computation: the pattern underneath the year, what each
// event adds on top of it, what is coming next, and what to order for it. They
// are deliberately in that order — the pattern is the context that makes the
// three below it readable, and a peak means nothing without a normal month to
// compare it against.
//
// Every surface above the pattern needs 24 months of history and says so when it
// does not have them. The festival calendar is maintained data rather than
// anything Amazon serves, so with it empty the peaks list shows pattern peaks
// only and the event table says there is nothing to measure.
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';

import styles from '../SellerIntelligence.module.css';
import SeasonalPattern from './components/SeasonalPattern';
import UpcomingPeaks from './components/UpcomingPeaks';
import FestivalLift from './components/FestivalLift';
import StockPlan from './components/StockPlan';

const Seasonal = () => {
  const navigate = useNavigate();
  return (
    <div className={styles.featureContainer}>
      <div className={styles.header}>
        <button className={styles.backButton}
          onClick={() => navigate('/dashboard/seller-intelligence/sales')}>
          <FiArrowLeft /> Back
        </button>
        <div className={styles.titleSection}>
          <div className={styles.iconTitle}><h1>Seasonal Performance</h1></div>
          <p>
            What your sales year looks like underneath the growth and the
            festival spikes, what is coming, and what to order for it.
          </p>
        </div>
      </div>

      <div className={styles.content}>
        <SeasonalPattern />
        <UpcomingPeaks />
        <FestivalLift />
        <StockPlan />
      </div>
    </div>
  );
};

export default Seasonal;
